import React from 'react'
import Link from 'gatsby-link'
import { injectIntl, intlShape, FormattedRelative } from 'react-intl';
import omit from 'object.omit'

const IntlLink = (props) => (
  <Link
    {...omit(props, 'intl')}
    to={props.intl.locale === 'it' ? `/it${props.to}` : props.to}
  />
);

export default injectIntl(IntlLink);



// WEBPACK FOOTER //
// ./src/components/IntlLink.js